import { useConnectionCRUDActions } from '@mm/state/actions/ConnectionsCRUDActions';
import KlaviyoController from '@mm/state/controllers/KlaviyoController';
import ConnectionModel from '@mm/state/model/ConnectionModel';
import { useEffect, useState } from 'react';

export const useConnectOauthToken = (
  popupName: string,
  popupEventType: string,
  onDone: () => void,
) => {
  const [popup, setPopup] = useState<Window | null>(null);
  const { create } = useConnectionCRUDActions();

  useEffect(() => {
    if (!popup) {
      return;
    }
    const onMessage = (event: any) => {
      if (event.origin !== new URL(API_URL).origin) {
        return;
      }
      const { data } = event;
      if (data?.type === popupEventType) {
        popup.close();
        setPopup(null);
        onDone();
      }
    };
    window.addEventListener('message', onMessage);
    const checkIfPopupClosedInterval = setInterval(() => {
      if (popup.closed) {
        setPopup(null);
      }
    }, 1000);
    return () => {
      window.removeEventListener('message', onMessage);
      clearInterval(checkIfPopupClosedInterval);
    };
  }, [popup, setPopup, onDone, popupEventType]);

  const authorize = async (webhookId: number) => {
    const url = await KlaviyoController.getOauthUrl(webhookId);
    const popup = window.open(url.link, popupName, 'width=600,height=600');
    setPopup(popup);
  };

  const connectToken = async (
    facebookPageId: number,
    hasNativeIntegrationsFeature: boolean,
    showUpgradeModal: (onSuccessBilling?: () => void) => void,
    connection: ConnectionModel | undefined,
    params: Partial<ConnectionModel>,
  ) => {
    const connect = async () => {
      if (!hasNativeIntegrationsFeature) {
        showUpgradeModal(connect);
      } else if (!connection) {
        const newConnection = await create(facebookPageId, params);
        if (newConnection?.id) {
          authorize(newConnection.id);
        }
      } else {
        authorize(connection.id);
      }
    };
    return connect();
  };

  return connectToken;
};
